import { render, staticRenderFns } from "./ApiDialog.vue?vue&type=template&id=25832977&scoped=true&"
import script from "./ApiDialog.vue?vue&type=script&lang=js&"
export * from "./ApiDialog.vue?vue&type=script&lang=js&"
import style0 from "./ApiDialog.vue?vue&type=style&index=0&id=25832977&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25832977",
  null
  
)

export default component.exports